export const environment = {
	production: false,
	baseUrl: 'https://sre-ticket-classifier-agents.mottu.io',
	keycloak: {
		url: 'https://sso.mottu.io',
		realm: 'Admin',
		clientId: 'sre-portal-front-client',
	},
};
